// department-list.component.ts
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CrudServiceService } from 'src/app/services/crudService/crud-service.service';
import { environment } from 'src/environments/environment';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { usersService } from '../../../services/tikaUser/user.service';

@Component({
  selector: 'app-department-list',
  templateUrl: './department-list.component.html',
  styleUrls: ['./department-list.component.scss']
})
export class DepartmentListComponent implements OnInit {
  displayedColumns: string[] = ['name', 'description', 'action'];
  dataSource: any = new MatTableDataSource;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  length = 100;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageEvent: PageEvent;
  reserveData: any;
  isCreatingNew = false;
  isEditingId: string | null = null;
  newDepartment: any = {
    name: '',
    description: '',
    isDefault: false
  };
  editDepartmentData: any = {};

  constructor(
    private crudService: CrudServiceService,
    private dialog: DialogComponent,
    private matDialog: MatDialog,
    private apiService:usersService,
  ) { }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.getAllDepartments();
  }

  getPageSizeOptions(): number[] {
    if (this.paginator.length > 100)
      return [5, 10, 50, 100, this.dataSource.data.length];
    else
      return [5, 10, 50, 100];
  }

  getAllDepartments() {
    this.crudService.getAll(environment.api.department,{}).then((res: any) => {
      this.reserveData = res.data;
      this.dataSource.data = this.reserveData;
      this.length = res.length;
    });
  }

  startCreating() {
    this.isCreatingNew = true;
  }

  cancelCreating() {
    this.isCreatingNew = false;
    this.newDepartment = {
      name: '',
      description: '',
      isDefault: false
    };
  }

  createDepartment() {
    if (!this.newDepartment.name) {
      this.apiService.snackbarCmp.toastError("Name is required");
      return;
    }

    this.crudService.add(this.newDepartment, `${environment.api.department}`)
      .then((res: any) => {
        this.apiService.snackbarCmp.toastSuccess("Department created successfully");
        this.isCreatingNew = false;
        this.newDepartment = {
          name: '',
          description: '',
          isDefault: false
        };
        this.getAllDepartments();
      })
      .catch(err => {
        console.error("Error creating department:", err);
        this.apiService.snackbarCmp.toastError("Failed to create department");
      });
  }

  startEditing(department: any) {
    this.isEditingId = department._id;
    this.editDepartmentData = {
      name: department.name,
      description: department.description,
      isDefault: department.isDefault
    };
  }

  cancelEditing() {
    this.isEditingId = null;
    this.editDepartmentData = {};
  }

  updateDepartment(id: string) {
    if (!this.editDepartmentData.name) {
      this.apiService.snackbarCmp.toastError("Name is required");
      return;
    }

    const updateData = {
      ...this.editDepartmentData,
      _id: id
    };

    this.crudService.edit(updateData, `${environment.api.department}/${id}`)
      .then((res: any) => {
        this.apiService.snackbarCmp.toastSuccess("Department updated successfully");
        this.isEditingId = null;
        this.getAllDepartments();
      })
      .catch(err => {
        console.error("Error updating department:", err);
        this.apiService.snackbarCmp.toastError("Failed to update department");
      });
  }

  deleteDepartment(id: string) {
    this.dialog.openDialog("Delete Department", "Are you sure to delete this department?").then((isOkay) => {
      if (isOkay) {
        this.crudService.delete(id, environment.api.department).then((res) => {
          this.getAllDepartments();
        });
      }
    });
  }

  ngOnInit(): void {
  }
}